var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "10px 0 0 20px" } },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "left", "label-width": "80px" } },
        [
          _c("el-form-item", { attrs: { label: "国际化转换" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "450px",
                  float: "left",
                  "margin-right": "5px"
                }
              },
              [
                _c("label", { staticStyle: { color: "#1890ff" } }, [
                  _vm._v("编码：")
                ]),
                _c("span", { staticStyle: { "margin-left": "40px" } }, [
                  _vm._v("格式化显示 ")
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "170px" },
                    model: {
                      value: _vm.formatStr,
                      callback: function($$v) {
                        _vm.formatStr = $$v
                      },
                      expression: "formatStr"
                    }
                  },
                  [
                    _c("el-option", { attrs: { value: "{code}" } }),
                    _c("el-option", { attrs: { value: "$t('{code}')" } }),
                    _c("el-option", { attrs: { value: "this.$t('{code}')" } }),
                    _c("el-option", {
                      attrs: { value: "this.view.$t('{code}')" }
                    }),
                    _c("el-option", {
                      attrs: { value: "this._view.$t('{code}')" }
                    }),
                    _c("el-option", { attrs: { value: "lang.t('{code}')" } })
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "right" },
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.chineseName = _vm.$t(_vm.code)
                      }
                    }
                  },
                  [_vm._v("转换编码")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { width: "170px", float: "left" } },
              [
                _c("label", { staticStyle: { color: "#1890ff" } }, [
                  _vm._v("中文名：")
                ]),
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "right" },
                    attrs: { type: "primary" },
                    on: { click: _vm.toCode }
                  },
                  [_vm._v("转换中文名")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                staticStyle: { width: "450px", "margin-right": "5px" },
                attrs: { type: "textarea", rows: 10 },
                model: {
                  value: _vm.code,
                  callback: function($$v) {
                    _vm.code = $$v
                  },
                  expression: "code"
                }
              }),
              _c("el-input", {
                staticStyle: { width: "170px" },
                attrs: { type: "textarea", rows: 10 },
                model: {
                  value: _vm.chineseName,
                  callback: function($$v) {
                    _vm.chineseName = $$v
                  },
                  expression: "chineseName"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }